<template>
  <div style="display: inline;">
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/basic/material/skill/page" getKey="rows" :columns="columns">
      <!-- 左侧按钮插槽 -->
      <template #buttonsL="scope">
        <el-button type="primary" size="mini" @click="yt.showEditDialog('xinzeng', null, 'w1', beforeShowEditDialogInsert)" v-if="utils.checkPower('web_base_matter_skill_requirement_create')">
          {{ $t('xinzeng') }}
        </el-button>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1" v-if="utils.checkPower('web_base_matter_skill_requirement_update')">
            <el-button type="text" @click="yt.showEditDialog('bianji', scope.row)">{{ $t('bianji') }} </el-button>
          </el-col>
          <el-col :span="0.1" v-if="utils.checkPower('web_base_matter_skill_requirement_delete')">
            <el-button type="text" :loading="yt.editObj.loading" class="font-color-danger" @click="yt.remove(scope.row, '/web/basic/material/skill/delete')">{{ $t('shanchu') }} </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('gongxu')" required>
            <yi_data_select type="work_procedure" ref="wp" :ids.sync="yt.editObj.workProcedureId" @finishLoad="yt.editObj.workProcedureId = $refs.wp.items[0].id"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('yaoqiujineng')" required>
            <yi_data_select type="skill" :ids.sync="yt.editObj.skillId"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('yaoqiudengji')" required>
            <yi_dictionary_select :max="1" type="EMPLOYEE_SKILL_LEVEL" :ids.sync="yt.editObj.skillLevel"></yi_dictionary_select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" :loading="yt.editObj.loading" @click="yt.req('POST', '/web/basic/material/skill/create', beforeAdd)" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <template v-if="yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('gongxu')" required>
            <yi_data_select type="work_procedure" :ids.sync="yt.editObj.workProcedureId"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('yaoqiujineng')" required>
            <yi_data_select type="skill" :ids.sync="yt.editObj.skillId"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('yaoqiudengji')" required>
            <yi_dictionary_select :max="1" type="EMPLOYEE_SKILL_LEVEL" :ids.sync="yt.editObj.skillLevel"></yi_dictionary_select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" :loading="yt.editObj.loading" @click="yt.req('POST', '/web/basic/material/skill/update')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script type="text/javascript">
export default {
  name: 'web_base_matter_skill_requirement',
  data() {
    return {
      columns: [
        {
          label: 'gongxu',
          prop: 'workProcedure.desc'
        },
        {
          label: 'yaoqiujineng',
          prop: 'skill.skillName'
        },
        {
          label: 'yaoqiudengji',
          prop: 'skillLevel',
          type: 'dictionary',
          key: 'EMPLOYEE_SKILL_LEVEL'
        },
        {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time'
        },
        {
          label: 'caozuo',
          type: 'slot',
          fixed: 'right',
          width: 120
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = {
        materialId: this.$attrs.material.id,
        pageNum: 1,
        pageSize: 100
      };
      this.yt.get(1);
      this.yt.isShowPagination = false;
    }, 300);
  },
  methods: {
    // 新增之前处理数据
    beforeShowEditDialogInsert(row) {
      row.skillLevel = "1";
      return row;
    },
    beforeAdd(params) {
      params.materialId = this.$attrs.material.id;
      params.workProcedureId = this.yt.editObj.workProcedureId;
      params.skillId = this.yt.editObj.skillId;
      params.skillLevel = this.yt.editObj.skillLevel;
      return params;
    }
  }
};
</script>

<style scoped lang="scss"></style>
